import { isEmpty } from "../../../utils";
import { ApplicationSettings } from "./ApplicationSettings";

export default class VkGroupsApplicationSettings extends ApplicationSettings {

    constructor(s?: Partial<VkGroupsApplicationSettings>) {
        super();
        if (s) this.update(s);
    }

    public accessToken: string;
    public isAccessTokenEncrypted: boolean;
    public isUserAccessTokenEncrypted: boolean;
    public isUserRefreshTokenEncrypted: boolean;
    public userAuthConnected: boolean;
    public vkUserId: string;
    public vkScreenName: string;
    public managedCommunityId: number;
    public userAccessToken: string;
    public userRefreshToken: string;
    public vkDeviceId: string;
    public vkOAuthState: string;
    public userTokenExpiresAt: string;

    get hasCommunityToken() {
        return !isEmpty(this.accessToken);
    }

    get hasUserToken() {
        return this.userAuthConnected || !isEmpty(this.userAccessToken);
    }

    get isUserTokenExpired() {
        if (isEmpty(this.userTokenExpiresAt))
            return false;

        const expiresAt = Date.parse(this.userTokenExpiresAt);
        if (Number.isNaN(expiresAt))
            return false;

        return expiresAt <= Date.now();
    }

    get hasGroup() {
        return this.managedCommunityId > 0 && !isEmpty(this.vkScreenName);
    }

    get isValid() {
        return !isEmpty(this.accessToken);
    }

    update(entity: Partial<VkGroupsApplicationSettings>, allowUndefined = false) {
        super.update(entity, allowUndefined);
    }

    toJson() {
        return {
            accessToken: this.accessToken,
            isAccessTokenEncrypted: this.isAccessTokenEncrypted,
            vkScreenName: this.vkScreenName,
            managedCommunityId: this.managedCommunityId,
            userAccessToken: this.userAccessToken,
            userRefreshToken: this.userRefreshToken,
            vkDeviceId: this.vkDeviceId,
            vkOAuthState: this.vkOAuthState,
            userTokenExpiresAt: this.userTokenExpiresAt,
            isUserAccessTokenEncrypted: this.isUserAccessTokenEncrypted,
            isUserRefreshTokenEncrypted: this.isUserRefreshTokenEncrypted,
        };
    }

    static fromJson(json: any): VkGroupsApplicationSettings {
        return new VkGroupsApplicationSettings({ ...json });
    }
}
